import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { TextField, MenuItem } from '@mui/material';
import { US_STATES } from '../types/us-states';
const SelectState = (props) => {
    const { name, onChange, onBlur, value, error, helperText, label } = props;
    const stateOptions = useMemo(() => US_STATES.map((option) => (_jsx(MenuItem, { value: option.abbreviation, children: option.name }, option.abbreviation))), []);
    return (_jsx(TextField, { select: true, fullWidth: true, required: true, name: name, label: label, type: 'text', variant: 'outlined', value: value, "data-testid": `${name}-select`, onChange: onChange, onBlur: onBlur, error: error, helperText: helperText, children: stateOptions }));
};
export default SelectState;
